 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CompaniesCore":"CompaniesCore","Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles":"Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles","Companies~CompanyStaff~PhotoAlbums~ProfileStaff":"Companies~CompanyStaff~PhotoAlbums~ProfileStaff","Companies":"Companies","PhotoAlbums":"PhotoAlbums","ProfileStaff":"ProfileStaff","SettingsBasic":"SettingsBasic","CompanyCore":"CompanyCore","CompanyStaffCore":"CompanyStaffCore","Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles":"Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles","Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson":"Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson","CompanyStaff":"CompanyStaff","Vehicles":"Vehicles","Company":"Company","CreatingEmployee":"CreatingEmployee","ProfileStaffPerson":"ProfileStaffPerson","CreatingCompany":"CreatingCompany","Login":"Login","Profile":"Profile","ForgotPassword":"ForgotPassword","PhotoAlbum":"PhotoAlbum","PhotosCore":"PhotosCore","ProfileCore":"ProfileCore","ProfileStaffCore":"ProfileStaffCore","SettingsBG~SettingsBanner~SettingsLogo":"SettingsBG~SettingsBanner~SettingsLogo","SettingsBG":"SettingsBG","SettingsBanner":"SettingsBanner","SettingsLogo":"SettingsLogo","SettingsCore":"SettingsCore","VehiclesCore":"VehiclesCore","home":"home"}[chunkId]||chunkId) + "." + {"CompaniesCore":"04b8c6f8","Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles":"2e57ca79","Companies~CompanyStaff~PhotoAlbums~ProfileStaff":"8c3e01d7","Companies":"54f16789","PhotoAlbums":"59906dae","ProfileStaff":"aa70f3d8","SettingsBasic":"4c30a8f3","CompanyCore":"24bc75c7","CompanyStaffCore":"0fa33a6e","Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles":"9c5885fb","Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson":"a66880d5","CompanyStaff":"b374bf54","Vehicles":"3753bb31","Company":"c93feee6","CreatingEmployee":"aa7b3868","ProfileStaffPerson":"80a2db2a","CreatingCompany":"ab65d008","Login":"826ce9b5","Profile":"5b8d66bc","ForgotPassword":"250b2084","PhotoAlbum":"d4111c72","PhotosCore":"2187766e","ProfileCore":"a76a686b","ProfileStaffCore":"ed73c9c6","SettingsBG~SettingsBanner~SettingsLogo":"87d7f440","SettingsBG":"58249434","SettingsBanner":"1fd4bbda","SettingsLogo":"71fadde4","SettingsCore":"6bcef151","VehiclesCore":"600558a6","home":"0005073f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Companies":1,"PhotoAlbums":1,"ProfileStaff":1,"SettingsBasic":1,"CompanyStaff":1,"Vehicles":1,"Company":1,"CreatingEmployee":1,"ProfileStaffPerson":1,"Profile":1,"PhotoAlbum":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CompaniesCore":"CompaniesCore","Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles":"Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles","Companies~CompanyStaff~PhotoAlbums~ProfileStaff":"Companies~CompanyStaff~PhotoAlbums~ProfileStaff","Companies":"Companies","PhotoAlbums":"PhotoAlbums","ProfileStaff":"ProfileStaff","SettingsBasic":"SettingsBasic","CompanyCore":"CompanyCore","CompanyStaffCore":"CompanyStaffCore","Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles":"Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles","Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson":"Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson","CompanyStaff":"CompanyStaff","Vehicles":"Vehicles","Company":"Company","CreatingEmployee":"CreatingEmployee","ProfileStaffPerson":"ProfileStaffPerson","CreatingCompany":"CreatingCompany","Login":"Login","Profile":"Profile","ForgotPassword":"ForgotPassword","PhotoAlbum":"PhotoAlbum","PhotosCore":"PhotosCore","ProfileCore":"ProfileCore","ProfileStaffCore":"ProfileStaffCore","SettingsBG~SettingsBanner~SettingsLogo":"SettingsBG~SettingsBanner~SettingsLogo","SettingsBG":"SettingsBG","SettingsBanner":"SettingsBanner","SettingsLogo":"SettingsLogo","SettingsCore":"SettingsCore","VehiclesCore":"VehiclesCore","home":"home"}[chunkId]||chunkId) + "." + {"CompaniesCore":"31d6cfe0","Companies~CompanyStaff~PhotoAlbums~ProfileStaff~SettingsBasic~Vehicles":"31d6cfe0","Companies~CompanyStaff~PhotoAlbums~ProfileStaff":"31d6cfe0","Companies":"34f8496a","PhotoAlbums":"7ccd205f","ProfileStaff":"34f8496a","SettingsBasic":"137279a8","CompanyCore":"31d6cfe0","CompanyStaffCore":"31d6cfe0","Company~CompanyStaff~CreatingCompany~CreatingEmployee~Login~Profile~ProfileStaffPerson~Vehicles":"31d6cfe0","Company~CompanyStaff~CreatingEmployee~ProfileStaffPerson":"31d6cfe0","CompanyStaff":"34f8496a","Vehicles":"605b6e69","Company":"3155dd03","CreatingEmployee":"34f8496a","ProfileStaffPerson":"34f8496a","CreatingCompany":"31d6cfe0","Login":"31d6cfe0","Profile":"34f8496a","ForgotPassword":"31d6cfe0","PhotoAlbum":"f23063fe","PhotosCore":"31d6cfe0","ProfileCore":"31d6cfe0","ProfileStaffCore":"31d6cfe0","SettingsBG~SettingsBanner~SettingsLogo":"31d6cfe0","SettingsBG":"31d6cfe0","SettingsBanner":"31d6cfe0","SettingsLogo":"31d6cfe0","SettingsCore":"31d6cfe0","VehiclesCore":"31d6cfe0","home":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
